import municipalitiesJson from './assets/municipalities.json';
import prefecturesJson from './assets/prefectures.json';
import sitesJson from './assets/sites.json';
import terrainJson from './assets/terrain.json';
import expresswaysJson from './assets/expressways.json';
import { parseMapLines, parseMunicipalities, parsePrefPoints, parseSiteInputs } from './load';
import type { MapLines, Municipality, PrefPoint, SiteInput } from './types';

export {
  DataError,
  parseMapLines,
  parseMunicipalities,
  parsePrefPoints,
  parseSiteDefs,
  parseSiteInputs,
  parseTerrain,
} from './load';
export * from './types';

/** 同梱の現場データ（15 件）を検査して読み込む。 */
export function loadSiteInputs(prefNames: ReadonlySet<string>): SiteInput[] {
  return parseSiteInputs(sitesJson, terrainJson, prefNames);
}

/** 住所照合に使う、都道府県と市区町村の代表地点を検査して読み込む。 */
export function loadPlaces(): { prefs: PrefPoint[]; cities: Municipality[] } {
  const prefs = parsePrefPoints(prefecturesJson);
  return { prefs, cities: parseMunicipalities(municipalitiesJson, prefs) };
}

/** 全国表示の県境と高速道路の線を検査して読み込む。 */
export function loadMapLines(): MapLines {
  return parseMapLines(prefecturesJson, expresswaysJson);
}
